import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/homes/1';
const OPINION_URL = 'quotes';

export default {
  index(succ) {
    axios.get(INDEX_URL)
      .then((response) => { succ(response); });
  },
  getOpinion(succ) {
    axios.get(OPINION_URL)
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/home.js